import {createElement, Component, PropTypes} from 'rlink-react';
import FileInput from './FileInput';

export default class ImageInput extends FileInput {
  get dropLabel () {
    return 'Upload or drop image from here.';
  }

  renderDownloadPreview () {
    return <img src={URL.createObjectURL(this.state.blob)} style={{maxWidth: '50%'}} />;
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-forms/inputs/ImageInput.jsx